export interface MultiStepForm {
	id: string;
	validations: MultiStepFormValidations;
	ownerCenterId: number;
	collaboratorCenterIds?: number[];
	collaboratorAllCenters: boolean;

	//program
	ownerCenterIds?: number[] | null;
}

export enum MultiStepFormValidationStatus {
	completed = 'completed',
	error = 'error',
	pass = 'pass',
}

//TODO, no idea how to type it, EventEditStep | JobEditStep cause error in MultiStepFormEdit.vue
export type MultiStepFormStep = any;

export type MultiStepFormValidations = Partial<
	Record<MultiStepFormStep, MultiStepFormValidationStatus>
>;

export enum MultiStepFormModeValue {
	view = 'view',
	edit = 'edit',
}

export type MultiStepFormMode = MultiStepFormModeValue;
